var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.828,27.889H24.172c-1.104,0-2,0.896-2,2v26.503v9.72c0,1.104,0.896,2,2,2h22.182h25.475c1.104,0,2-0.896,2-2V29.889 C73.828,28.784,72.933,27.889,71.828,27.889z M26.172,64.111v-7.184l6.285-10.886l10.433,18.07H26.172z M69.828,64.111h-22.32 l-13.319-23.07c-0.357-0.619-1.018-1-1.732-1s-1.375,0.381-1.732,1l-4.553,7.886V31.889h43.656V64.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,50.899c4.885,0,8.858-3.973,8.858-8.858c0-4.884-3.974-8.858-8.858-8.858s-8.858,3.974-8.858,8.858 C47.542,46.926,51.516,50.899,56.4,50.899z M56.4,37.184c2.679,0,4.858,2.179,4.858,4.858S59.079,46.9,56.4,46.9 s-4.858-2.18-4.858-4.858S53.722,37.184,56.4,37.184z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.3941afa2095d8f60657c89af335f9ec7.svg";
export { ForwardRef as ReactComponent };